export default {"src":"https://fishbrain.com/_next/static/media/marlin.9473f0cb.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};